/* eslint-disable @typescript-eslint/explicit-function-return-type */
/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { ErrorType } from '../../modules/Network/orvalHTTPInterface';
import { HTTP } from '../../modules/Network/orvalHTTPInterface';

import type { ApiSeoLocationNeighborhoodReviewsListParams } from './model/apiSeoLocationNeighborhoodReviewsListParams';
import type { PaginatedProviderRatingList } from './model/paginatedProviderRatingList';

/**
 * Returns provider ratings for a given SEO location.
 */
export const apiSeoLocationNeighborhoodReviewsList = (
  countryUrlPrefix: string,
  language: string,
  neighborhood: string,
  city: string,
  regionSlug: string,
  seoSlug: string,
  params?: ApiSeoLocationNeighborhoodReviewsListParams,
  signal?: AbortSignal
) => {
  return HTTP<PaginatedProviderRatingList>({
    url: `/api/v7/seo-location/${countryUrlPrefix}/${language}/${neighborhood}--${city}--${regionSlug}--${seoSlug}/reviews/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getApiSeoLocationNeighborhoodReviewsListQueryKey = (
  countryUrlPrefix?: string,
  language?: string,
  neighborhood?: string,
  city?: string,
  regionSlug?: string,
  seoSlug?: string,
  params?: ApiSeoLocationNeighborhoodReviewsListParams
) => {
  return [
    `/api/v7/seo-location/${countryUrlPrefix}/${language}/${neighborhood}--${city}--${regionSlug}--${seoSlug}/reviews/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getApiSeoLocationNeighborhoodReviewsListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiSeoLocationNeighborhoodReviewsList>>,
  TError = ErrorType<unknown>
>(
  countryUrlPrefix: string,
  language: string,
  neighborhood: string,
  city: string,
  regionSlug: string,
  seoSlug: string,
  params?: ApiSeoLocationNeighborhoodReviewsListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiSeoLocationNeighborhoodReviewsList>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiSeoLocationNeighborhoodReviewsListQueryKey(
      countryUrlPrefix,
      language,
      neighborhood,
      city,
      regionSlug,
      seoSlug,
      params
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiSeoLocationNeighborhoodReviewsList>>
  > = ({ signal }) =>
    apiSeoLocationNeighborhoodReviewsList(
      countryUrlPrefix,
      language,
      neighborhood,
      city,
      regionSlug,
      seoSlug,
      params,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(countryUrlPrefix && language && neighborhood && city && regionSlug && seoSlug),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof apiSeoLocationNeighborhoodReviewsList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiSeoLocationNeighborhoodReviewsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSeoLocationNeighborhoodReviewsList>>
>;
export type ApiSeoLocationNeighborhoodReviewsListQueryError = ErrorType<unknown>;

export function useApiSeoLocationNeighborhoodReviewsList<
  TData = Awaited<ReturnType<typeof apiSeoLocationNeighborhoodReviewsList>>,
  TError = ErrorType<unknown>
>(
  countryUrlPrefix: string,
  language: string,
  neighborhood: string,
  city: string,
  regionSlug: string,
  seoSlug: string,
  params?: ApiSeoLocationNeighborhoodReviewsListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiSeoLocationNeighborhoodReviewsList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiSeoLocationNeighborhoodReviewsListQueryOptions(
    countryUrlPrefix,
    language,
    neighborhood,
    city,
    regionSlug,
    seoSlug,
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}
